import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const Introduction = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#FFFFFF] via-[#F8F6FF] via-[#E8F3FF] to-[#FFFFFF]">
      <div className=" px-[240px] pb-[80px]  w-[1920px]">
        <PageTitle title="我们可以做什么？" />
        <PageSubTitle title="企业出海多场景网络支持" />
        <div className="flex mt-[90px]">
          <div className="flex flex-col gap-[30px]">
            <img src="/imgs/kwan/3-1.png" className="w-[330px] h-[200px]" />
            <img src="/imgs/kwan/3-2.png" className="w-[330px] h-[200px]" />
            <img src="/imgs/kwan/3-3.png" className="w-[330px] h-[200px]" />
          </div>
          <div className="flex-1 px-[70px] w-full flex flex-col items-center justify-center">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[50px] text-[#0F2B5B] text-center">
              企业出海办公网络加速
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[24px] text-[#333333] mt-[50px] text-center">
              访问国内或国外办公需求场景的网络加速服务，企业办公、海外SaaS应用、企业海外推广、品牌宣传，异地传输，不同办公点的跨国际互通互访。提供企业后台管理系统，可以根据公司架构针对部门分类管理，线路调度分配、IP定制化服务，自定义设置访问IP黑白名单功能等。并且支持轻松满足千人团队同时在线使用。
            </div>
            <div className="w-[170px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] mt-[67px] flex items-center justify-center">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-medium text-[25px] text-[#ffffff]">
                查看详情
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-[30px]">
            <img src="/imgs/kwan/3-4.png" className="w-[330px] h-[200px]" />
            <img src="/imgs/kwan/3-5.png" className="w-[330px] h-[200px]" />
            <img src="/imgs/kwan/3-6.png" className="w-[330px] h-[200px]" />
          </div>
        </div>
      </div>
    </div>
  );
};
